import React from "react";
import { HashRouter, Routes, Route, Navigate } from "react-router-dom";

// Auth pages
import Login from "./pages/LoginPage/Login";
import Register from "./pages/RegisterPage/Register";
import CreateCompany from "./pages/CreateCompanyPage/CreateCompany";
import JoinCompany from "./pages/JoinCompanyPage/JoinCompany";
import CompanySelection from "./pages/CompanySelectionPage/CompanySelection";
import Unauthorized from "./pages/UnauthorizedPage/Unauthorized";
import AdminLogin from "./admin/pages/AdminLoginPage/AdminLogin";

// Protected Route
import ProtectedRoute from "./Components/auth/ProtectedRoute";

// client layout + pages
import DashboardLayout from "./Components/layout/DashboardLayout";
import Dashboard from "./pages/Dashboardpage/Dashboard";
import Values from "./pages/Valuespage/Values";
import CompetenciesList from "./pages/CompetenciesListpage/CompetenciesList";
import CompetencyRubric from "./pages/Competenciespage/Competencies";
import Diagnostic from "./pages/Diagnosticpage/Diagnostic";
import DevelopmentPlans from "./pages/Learningplanspage/LearningPlans";
import LearningLibrary from "./pages/LearningLibrarypage/LearningLibrary";
import LearningItemDetails from "./pages/LearningLibrarypage/LearningItemDetails";
import Communities from "./pages/Communitiespage/Communities";
import Analytics from "./pages/Analyticspage/Analytics";
import Settings from "./pages/Settingspage/Settings";
import Team from "./pages/Teampage/Team";
import DiagnosticManagement from "./pages/DiagnosticManagementpage/DiagnosticManagement";
import Help from "./pages/Helppage/HelpSupport";
import Logout from "./pages/Logoutpage/Logout";
import Onboarding from "./pages/OnboardingPage/Onboarding";

// ADMIN layout + pages
import AdminLayout from "./admin/components/layout/AdminLayout";
import AdminDashboard from "./admin/pages/Admindashboardpage/AdminDashboard";
import AdminCompanies from "./admin/pages/Allcompanies/Companies";
import CompanyDetails from "./admin/pages/Allcompanies/CompanyDetails";
import CompanyCompetenciesPage from "./admin/pages/Allcompanies/CompanyCompetenciesPage";
import CompanyUnpackValuesPage from "./admin/pages/Allcompanies/CompanyUnpackValuesPage";
import CompanyDiagnosticFormsPage from "./admin/pages/Allcompanies/CompanyDiagnosticFormsPage";
import AdminCommunities from "./admin/pages/Communities/AdminCommunities";
import AdminAnalytics from "./admin/pages/Adminanalytics/AdminAnalytics";
import AdminLearningLibrary from "./admin/pages/LearningLibrary/AdminLearningLibrary";
import CompetencySetEditor from "./admin/pages/CompetencySets/CompetencySetEditor";
import Users from "./admin/pages/Users";
import AdminSettings from "./admin/pages/AdminSettings/AdminSettings";
import AdminHelp from "./admin/pages/Adminhelp/AdminHelp";

export default function App() {
  return (
    <HashRouter>
      <Routes>
        {/* Public Routes */}
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/create-company" element={<CreateCompany />} />
        <Route path="/join-company" element={<JoinCompany />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/unauthorized" element={<Unauthorized />} />
        <Route path="/logout" element={<Logout />} />

        {/* Company Selection - Protected (requires auth, but not company) */}
        <Route
          path="/company-selection"
          element={
            <ProtectedRoute>
              <CompanySelection />
            </ProtectedRoute>
          }
        />

        {/* Onboarding - Protected (requires auth + company) */}
        <Route
          path="/onboarding"
          element={
            <ProtectedRoute requireCompany={true}>
              <Onboarding />
            </ProtectedRoute>
          }
        />

        {/* Client Area - Protected (requires authentication and company) */}
        <Route
          path="/"
          element={
            <ProtectedRoute requireCompany={true}>
              <DashboardLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Navigate to="dashboard" replace />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="values" element={<Values />} />
          <Route path="competencies-list" element={<CompetenciesList />} />
          <Route path="competencies" element={<CompetencyRubric />} />
          <Route path="diagnostic" element={<Diagnostic />} />
          <Route path="development-plans" element={<DevelopmentPlans />} />
          <Route path="learning-library" element={<LearningLibrary />} />
          <Route path="learning-library/:id" element={<LearningItemDetails />} />
          <Route path="communities" element={<Communities />} />
          <Route path="analytics" element={<Analytics />} />
          <Route path="settings" element={<Settings />} />
          <Route path="team" element={<Team />} />
          <Route path="diagnostic-management" element={<DiagnosticManagement />} />
          <Route path="help" element={<Help />} />
          <Route path="*" element={<Navigate to="dashboard" replace />} />
        </Route>

        {/* Admin Area - Protected (requires authentication + level 4+) */}
        <Route
          path="/admin"
          element={
            <ProtectedRoute requiredLevel={4}>
              <AdminLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Navigate to="dashboard" replace />} />
          <Route path="dashboard" element={<AdminDashboard />} />
          <Route path="companies" element={<AdminCompanies />} />
          <Route path="companies/:id" element={<CompanyDetails />} />
          <Route path="companies/:id/competencies" element={<CompanyCompetenciesPage />} />
          <Route path="companies/:id/unpack-values" element={<CompanyUnpackValuesPage />} />
          <Route path="companies/:id/diagnostic-forms" element={<CompanyDiagnosticFormsPage />} />
          <Route path="users" element={<Users />} />
          <Route path="communities" element={<AdminCommunities />} />
          <Route path="analytics" element={<AdminAnalytics />} />
          <Route path="learning-library" element={<AdminLearningLibrary />} />
          <Route path="competency-sets/:id" element={<CompetencySetEditor />} />
          <Route path="settings" element={<AdminSettings />} />
          <Route path="help" element={<AdminHelp />} />
          <Route path="*" element={<Navigate to="dashboard" replace />} />
        </Route>
      </Routes>
    </HashRouter>
  );
}
